module.exports = __webpack_public_path__ + "static/media/context.816201fc.md";